import { useState, useEffect } from 'react'
import { Space, message } from 'antd'
import Header, { FormData } from './components/header'
import List, { PageInfo } from './components/List'
import ModalData from './components/ModalData'
import { downloadFile } from '../../utils'
import {
  queryList,
  QueryListResponse,
  editorState,
  addProduct,
  downProductList,
} from '../../API/priceComparison'
import './index.scss'
export const pageSize = 10;
const tipError = errInfo => {
  message.error(
    (errInfo?.response?.data?.messages && errInfo?.response?.data?.messages?.[0]) ||
      errInfo?.response?.data?.resource ||
      errInfo?.message
  )
}
type QueryDataType = Partial<FormData>
const PriceComparison = () => {
  const [loading, setLoading] = useState(false)
  const [editorId, setEditorId] = useState("")
  const [queryData, setQueryData] = useState<QueryDataType>({})
  const [type, setType] = useState<"ADD" | "EDITOR" | undefined>(undefined)
  const [dataList, setDataList] = useState<QueryListResponse[]>([])
  const [pageInfo, setPageInfo] = useState<PageInfo>({
    total: 0,
    currentPage: 1,
  })
  /**
   * 格式化表单数据
   * @param data {FormData}
   * @returns {QueryDataType}
   */
  const getData = (data: FormData): QueryDataType => {
    const newData: QueryDataType = {}
    if (data.productId) {
      newData.productId = data.productId
    }
    if (data.state === 'OFF' || data.state === 'ON') {
      newData.state = data.state
    }
    return newData
  }
  /**
   * 点击查询
   * @param data {FormData}
   */
  const handleQuery = (data: FormData) => {
    const newData = getData(data)
    setQueryData(newData)
    getDataList(1, newData)
  }
  /**
   * 获取列表
   * @param currentPage {number}
   * @param data {QueryDataType}
   */
  const getDataList = (currentPage: number, data?: QueryDataType) => {
    setLoading(true)
    const from = (currentPage - 1) * pageSize
    queryList({
      from: from,
      to: pageSize * currentPage,
      ...(data || {}),
    })
      .then(res => {
        setDataList(res.data.data || [])
        setPageInfo({
          currentPage,
          total: res.data.total,
        })
      })
      .finally(() => {
        setLoading(false)
      }).catch((error) => {
        tipError(error)
      })
  }
  /**
   * 点击新增按钮
   */
  const handleAdd = () => {
    setType('ADD')
  }
  /**
   * 取消关闭弹窗
   */
  const onCancel = () => {
    setType(undefined)
  }
  /**
   * 下载文件
   * @param data {Blob | undefined}
   */
  const handleDownload = (data: FormData) => {
    const newData = getData(data)
    downProductList(newData)
      .then(res => {
        downloadFile(res.data, 'Targeted_Price')
      })
      .catch(error => {
        tipError(error)
      })
  }
  /**
   * 上传回调
   * @param data { {success?:boolean msg?: string} }
   */
  const handleImport = (data) => {
   if(data.success) {
     message.success(data.msg || "上传成功")
     getDataList(1, queryData)
   }else {
     message.error(data.msg || data.message || '上传失败')
   }
  }
  /**
   * 修改TargetedPrice
   * @param id string
   */
  const onChangeTargetedPrice = (id) => {
    setEditorId(id)
    setType("EDITOR")
  }
  /**
   * 切换分页
   * @param currentPage {number}
   */
  const onPageChange = currentPage => {
    setPageInfo({
      currentPage,
      total:pageInfo.total
    })
    getDataList(currentPage, queryData)
  }
  /**
   * 修改状态
   * @param id {string}
   * @param state {OFF | ON}
   */
  const changeStateHandler = (id:string, state:string) => {
    editorState(id, { state })
      .then(() => {
        message.success('修改成功')
        getDataList(pageInfo.currentPage, queryData)
      })
      .catch(error => {
        tipError(error)
      })
  }
  /**
   * 添加
   * @param data {QueryDataType}
   */
  const onAdd = (data) => {
    addProduct({
      state: 'OFF',
      productId: data.productId,
      targetPriceFen: data.targetPriceFen * 100,
    })
      .then(() => {
        message.success('添加成功')
        setType(undefined)
        getDataList(1)
      })
      .catch(error => {
        tipError(error)
      })
  }
  /**
   * 修改Targeted Price
   * @param data {QueryDataType}
   */
  const onEditor = (data) =>  {
  editorId &&
    editorState(editorId, { targetPriceFen: data.targetPriceFen * 100 })
      .then(() => {
        message.success('修改成功')
        setType(undefined)
        setEditorId('')
        getDataList(pageInfo.currentPage, queryData)
      })
      .catch(error => {
        tipError(error)
      })
  }

  useEffect(() => {
    getDataList(1)
  },[])
  
  return (
    <>
      <Space direction="vertical" className="price-comparison" size={30}>
        <Header
          onAdd={handleAdd}
          onDownload={handleDownload}
          onImport={handleImport}
          onQuery={handleQuery}
        />
        <List
          loading={loading}
          data={dataList}
          pageInfo={pageInfo}
          onChangeState={changeStateHandler}
          onPageChange={onPageChange}
          onChangeTargetedPrice={onChangeTargetedPrice}
        />
      </Space>
      <ModalData 
        type={type}
        onAdd={onAdd}
        onEditor={onEditor}
        onCancel={onCancel}
      />
    </>
  )
}

export default PriceComparison